import React, { useEffect } from 'react'
import PedidosYaStyle from '../../../../assets/css/components/admin/plugins/PedidosYaStyle';
import { BiX } from 'react-icons/bi'
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { useState, useContext } from 'react';
import axios from 'axios';
import { keyAccessToken, keyUserId } from '../../../../assets/js/SessionStorageNames';
import DateTime from '../../reports/components/DateTime';

export default function Campaign({name, sendCampaignFn}) {
    const sendCampaign = sendCampaignFn;

    const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
    const [showBadge, setShowBadge] = useState(false);
    const [colorError, setColorError] = useState(true);
    const [error, setError] = useState('');
    const [dateOne, setDataeOne] = useState('');
    const [dateTwo, setDataeTwo] = useState('');
    const globalContext = useContext(GlobalContext);
    const [isLoad, setIsLoad] = useState(false);
    const [priceLists, setPriceLists] = useState([]);
    const [percent, setPercent] = useState(0)
    const [pricesListId, setPricesListId] = useState(null);
    const [campaignName, setCampaignName] = useState('')
    const [campaignExcelFile, setCampaignExcelFile] = useState(null);

    const closeBadge = (e) => {
        e.preventDefault();
        setShowBadge(false);
    };

    useEffect(() => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) return;
        setIsLoad(true);

        axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`, {
            cancelToken: axiosCancelTokenSource.token,
            headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
            },
        }
        ).then(resp => {
            const data = resp.data.data;
            setPriceLists(data.priceLists);
            setIsLoad(false);
        })
            .catch((error) => {
                setIsLoad(false);
                setColorError(true);
                setError(`Algo salio mal ${error}`);
            }
            );
    }, [globalContext.currentEnterpriseId]);


    const hdlSaveCampaign = () => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) {
            setColorError(true);
            setError(`Debe seleccionar la empresa`);
            return;
        };

        setIsLoad(true)
        const selectedPriceListName = priceLists.find(pl => String(pl.id) === String(pricesListId))?.name || '';
        sendCampaign(entId, pricesListId, parseInt(percent), dateOne, dateTwo, campaignName.toLocaleLowerCase(), campaignExcelFile, selectedPriceListName)
            .then((resp) => {
                console.log(resp);
                setIsLoad(false);
                setShowBadge(true)
                setColorError(false);
                setError(`Proceso ejecutado con exito`);
            })
            .catch((error) => {
                console.log('error', error);
                setIsLoad(false);
                setColorError(true);
                setError(`Algo salio mal ${error}`);
                setShowBadge(true)
            })
    }

    const handleCampaignExcelFile = (event) => {
        const file = event.target.files?.[0] || null;
        if (!file) {
            setCampaignExcelFile(null);
            return;
        }

        const isExcel = /\.(xlsx|xls)$/i.test(file.name) || [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
        ].includes(file.type);

        if (!isExcel) {
            setCampaignExcelFile(null);
            setColorError(true);
            setError('Debe seleccionar un archivo Excel válido (.xlsx o .xls)');
            setShowBadge(true);
            event.target.value = '';
            return;
        }

        setCampaignExcelFile(file);
    }

    return (
        <>
            <PedidosYaStyle.ContBadgeError active={showBadge} error={colorError}>
                <PedidosYaStyle.Text size=".875rem" cl="#FFFFFF">
                    {error}
                </PedidosYaStyle.Text>
                <PedidosYaStyle.BtnToggleBadge onClick={(e) => closeBadge(e)}>
                    <BiX />
                </PedidosYaStyle.BtnToggleBadge>
            </PedidosYaStyle.ContBadgeError>
            <PedidosYaStyle.ContForm>
                <PedidosYaStyle.HeaderForm>
                    <PedidosYaStyle.Text size="14pt" fw="500" cl="#898989">
                        Crear campaña de {name}
                    </PedidosYaStyle.Text>
                </PedidosYaStyle.HeaderForm>
                <PedidosYaStyle.BodyForm>
                    <PedidosYaStyle.BodyFormGrid>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="12pt">
                                Fecha Desde
                            </PedidosYaStyle.Text>
                            <DateTime
                                setValue={setDataeOne}
                                valueDefaultText="Fecha Desde"
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="12pt">
                                Fecha Hasta
                            </PedidosYaStyle.Text>
                            <DateTime
                                setValue={setDataeTwo}
                                valueDefaultText="Fecha de Hasta"
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel jsc="flex-start">
                            <PedidosYaStyle.Text size="12pt">
                                Lista de Precio
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.select onChange={(e) => setPricesListId(e.target.value)}>
                                <option key="" value="">
                                    Seleccione una Lista de Precio
                                </option>
                                {
                                    priceLists.map(pl => {
                                        return (
                                            <option key={pl.id} value={pl.id}>
                                                {pl.name}
                                            </option>
                                        );
                                    })
                                }
                            </PedidosYaStyle.select>
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="12pt">
                                Porcentaje
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input style={{ marginBottom: 10 }} placeholder='Porcentaje' onChange={(e) => setPercent(e.target.value)} />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="12pt">
                                Nombre de la campaña
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input style={{ marginBottom: 10 }} placeholder='Nombre' onChange={(e) => setCampaignName(e.target.value)} />
                        </PedidosYaStyle.ContInputAndLabel>

                        <PedidosYaStyle.ContInputAndLabel>
                            <PedidosYaStyle.Text size="12pt">
                                Archivo Excel de tarifa (opcional)
                            </PedidosYaStyle.Text>
                            <PedidosYaStyle.Input
                                type="file"
                                accept=".xlsx,.xls"
                                style={{ marginBottom: 10 }}
                                onChange={handleCampaignExcelFile}
                            />
                        </PedidosYaStyle.ContInputAndLabel>

                    </PedidosYaStyle.BodyFormGrid>
                </PedidosYaStyle.BodyForm>
                <PedidosYaStyle.FooterForm>
                    <PedidosYaStyle.BtnSend disabled={isLoad} onClick={hdlSaveCampaign}>
                        {isLoad ? 'Enviando' : 'Enviar'}
                    </PedidosYaStyle.BtnSend>
                </PedidosYaStyle.FooterForm>
            </PedidosYaStyle.ContForm>
        </>
    )
}
